export default __webpack_public_path__ + "static/media/bench-window-seat-trapezoid-back.43045320.webp";